import { Azing } from '@azing/user';
import { environment } from '../environment';
import { Utils } from './utils';

import * as de from '../assets/i18n/de.json';
import * as en from '../assets/i18n/en.json';
import * as hr from '../assets/i18n/hr.json';

export class Lang {

  static getLanguagePack(): any {
    const userLang = Lang.getUserLangSetting();
    switch (userLang) {
      case 'en':
        return (en as any)?.default ?? en;
      case 'de':
        return (de as any)?.default ?? de;
      case 'hr':
        return (hr as any)?.default ?? hr;
      default:
        return (en as any)?.default ?? en;
    }
  }

  static getUserLangSetting(): string {
    try {
      const azingLanguage = Lang.getOnlyLocalized(((window as any).azing as Azing).language);
      const urlSegmentLanguage = Lang.getLanguageFromUrlSegment();
      const urlQueryParameterLanguage = Lang.getOnlyLocalized(Utils.getQueryParameter(environment.languageKey));
      const browserLanguage = Lang.getOnlyLocalized(Lang.getBrowserLang());
      if (azingLanguage) {
        // we use localization that is preset in 2sxc
        return azingLanguage;
      } else if (urlSegmentLanguage) {
        // we can use localization setting from url segment
        return urlSegmentLanguage;
      } else if (urlQueryParameterLanguage) {
        // we can use localization setting from query string
        return urlQueryParameterLanguage;
      } else if (browserLanguage) {
        // we can use localization setting from browser
        return browserLanguage;
      } else {
        // fallback to default language
        return environment.defaultLang;
      }
    } catch (error) {
      return environment.defaultLang;
    }
  }

  static getBrowserLang() {
    return window.navigator.language // works both in Mozilla and chrome
      || navigator.language // works both in Mozilla and chrome
      || (navigator as any).userLanguage // works in IE
      ;
  }

  static getOnlyLocalized(language: string): string {
    // there is no localization value
    if (!language) { return null; }

    // make it lowercase to be safe
    const languageLowercase = language.toLocaleLowerCase();

    // check is it in list of localization that are available
    if (environment.langs.indexOf(languageLowercase) > -1) {
      return languageLowercase;
    }

    // localization in not in list od known localizations of this app
    return null;
  }

  static getLanguageFromUrlSegment(): string {
    const urlSegments = window.location.pathname.split('/');
    for (let index = urlSegments.length; index > 0; index--) {
      const lg = Lang.getOnlyLocalized(urlSegments[index]);
      if (lg) {
        return lg;
      }
    }
    return null;
  }
}
